module.exports = __webpack_public_path__ + "img/ibc-international-bio-cosmetics-mission.9a3c3c14.png";